import { ReactNode } from 'react';

// Exodus wallet not supported on Stack'd Perps — render children directly.
export function ExodusWalletProvider({
  children,
}: {
  children: NonNullable<ReactNode>;
}) {
  return children;
}
